import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  MenuList,
  Paper,
} from "@mui/material";
import { FC, HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";

interface IStationsBulkSelectAllPaperProps extends HTMLAttributes<HTMLElement> {
  checked: boolean;
  onToggleAll: () => void;
}

/** Dropdown popup with a leading "Select all" toggle (mirrors the dynamic-forms multiselect). */
export const StationsBulkSelectAllPaper: FC<
  IStationsBulkSelectAllPaperProps
> = ({ children, checked, onToggleAll, ...paperProps }) => {
  const { t } = useTranslation();

  return (
    <Paper {...paperProps}>
      <MenuList dense disablePadding>
        <MenuItem
          onMouseDown={e => {
            e.preventDefault();
            onToggleAll();
          }}
        >
          <FormControlLabel
            label={t("general.SELECT_ALL")}
            control={
              <Checkbox sx={{ marginInlineEnd: 0.75 }} checked={checked} />
            }
          />
        </MenuItem>
      </MenuList>
      {children}
    </Paper>
  );
};
